import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import parse from 'html-react-parser'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { isFunction } from 'lodash'

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import IconButton from '@material-ui/core/IconButton';

import { t } from 'application-translator/dist/translate/translate.react.js';

library.add(faTimes);

const useStyles = makeStyles({
  iconBtn: {
    position: 'absolute',
    right: 20,
    top: 8,
  },
  icon: {
    width: 16, 
    height: 16,
    color: 'rgba(55,65,81)'
  },
  content: {
    maxWidth: 900,
    margin: 'auto',
    paddingTop: 32,
    paddingBottom: 32,
  },
  header: {
    // border-b border-gray-200
    borderBottom: '1px solid rgb(229,231,235)'
  }
})

const Agreement = ({ open, content = '', onClose }) => {
  const classes = useStyles()
  const handleClose = () => {
    if (isFunction(onClose)) onClose()
  }

  return (
    <Dialog
      open={open}
      scroll="paper"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth="xl"
      fullScreen={true}
    >
      <DialogTitle id="alert-dialog-title" className={classes.header}>
        <p>{t('Terms and Conditions')}</p>
        <IconButton aria-label="close" className={classes.iconBtn} onClick={handleClose}>
          <FontAwesomeIcon icon="times" className={classes.icon} />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box padding={2}><div className={classes.content}>{parse(content || '')}</div></Box>
      </DialogContent>
    </Dialog>
  )
}

export default Agreement
